import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageAuthorize } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';

import { LogItemWrapper } from './log-item-wrapper.component';

export const AuthorizeLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageAuthorize(log.message)) {
    Logger.error('Message is not of type OcppLogCallResultMessageAuthorize', {
      log,
    });
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack direction="column" gap={GapEnum.M}>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-authorize-message-request.id-tag',
            )}
          </Text>{' '}
          {log.message.parameters.idTag}
        </Stack>
        <Stack gap={GapEnum.S}>
          <Text bold>
            {t(
              'delmonicos-shared-sdk.ocpp-api-models-authorize-message-request.status',
            )}
          </Text>{' '}
          {log.message.result.idTagInfo?.status ?? '-'}
        </Stack>
      </Stack>
    </LogItemWrapper>
  );
};
